export const XXS = 480;
export const XS = 640;
export const SM = 768;
export const MD = 960;
export const LG = 1280;
export const XL = 1440;
export const XXL = 1920;
